import React, { Component } from 'react';
import './pages.css';

import Button from './button.js';

require('./Fonts/691970/0a9b9cc6-55eb-4369-97ed-87b3eefd433a.woff2');
require('./Fonts/691979/84e1d9b2-4a5e-42f7-b7bb-e9edadb46977.woff2');

const image1 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd1_wgdfqt.png';
const image2 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd2_k8s8x0.png';
const image3 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522256/chardesign/cd3_tdxwsk.png';
const image4 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd4_slm578.png';
const image5 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd5_d3zqyp.png';
const image6 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd6_xcduwt.png';
const image7 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd7_jokjo0.png';
const image8 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd8_zrmf1i.png';
const image9 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522258/chardesign/cd9_sfjvlb.png';
const image10 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522258/chardesign/cd10_tekkbl.png';
const image17 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522259/chardesign/cd17_ce7bti.png';
const image18 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522259/chardesign/cd18_ldejyk.png';
const image11 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522257/chardesign/cd11_cczkxj.png';
const image12 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522261/chardesign/cd12_kd1w9k.png';
const image13 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522258/chardesign/cd13_gowa0q.png';
const image14 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522258/chardesign/cd14_nx2jou.png';
const image15 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522258/chardesign/cd15_i8xhnn.png';
const image16 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522258/chardesign/cd16_vrvsmr.png';
const image19 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522258/chardesign/cd19_mwnz1f.png';
const image20 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522261/chardesign/cd20_csbkj4.png';
const image21 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522259/chardesign/cd21_ff2ue9.png';
const image22 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522259/chardesign/cd22_pwjoqk.png';
const image23 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522260/chardesign/cd23_odb5xc.png';
const image24 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522259/chardesign/cd24_typgcm.jpg';
const image25 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522261/chardesign/cd25_ja4r2o.png';
const image26 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522260/chardesign/cd26_yg6xcy.png';
const image27 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522260/chardesign/cd27_lqoho7.png';
const image28 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522260/chardesign/cd28_v8ccr0.jpg';
const image29 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522260/chardesign/cd29_iybuwm.png';
const image30 = 'https://res.cloudinary.com/dvba0h43j/image/upload/v1561522260/chardesign/cd30_z100gy.png';

const allExpandableImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
    image10,
    image17,
    image18,
    image11,
    image12,
    image13,
    image14,
    image15,
    image16,
    image19,
    image20,
    image21,
    image22,
    image23,
    image24,
    image25,
    image26,
    image27,
    image28,
    image29,
    image30,
];

let nextImage, prevImage, clearImage;

const handleKeyDown = (e) => {
    const key = e.keyCode;
    const escape = 27;
    const leftArrow = 37;
    const rightArrow = 39;

    if (key === escape) {
        clearImage && clearImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === rightArrow) {
        nextImage && nextImage();
        e.stopPropagation();
        e.preventDefault();
    } else if (key === leftArrow) {
        prevImage && prevImage();
        e.stopPropagation();
        e.preventDefault();
    }
};

class CharacterPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
        imageToShow: undefined
    };
  }

  componentDidMount() {
    document.addEventListener('keydown', handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', handleKeyDown);
  }

  render() {
    const { changePage } = this.props;
    const { imageToShow } = this.state;
    const setImage = (image) => {
        this.setState({ imageToShow: image });
    };

    nextImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + 1) % allExpandableImages.length]);
        }
    };

    prevImage = () => {
        if (!!imageToShow) {
            const index = allExpandableImages.indexOf(imageToShow);
            setImage(allExpandableImages[(index + allExpandableImages.length - 1) % allExpandableImages.length]);
        }
    };

    clearImage = () => setImage(undefined);

    return (
      <div>
        <div className={"modal-" + !!imageToShow}>
            <div className="backdrop" onClick={() => setImage(undefined)}></div>
            <img className="image-displayer" src={imageToShow} />
        </div>
        <div className="maincontent">
            <div className="header-bar-small">
                <div className="name-title light">
                    <h1 onClick={() => changePage("main")}>Christina Winchester</h1>
                </div>
                <div className="button-bar-small">
                    <Button changePage={changePage} pageName="character" innerClassName="btn-smaller" containerClassName="character-btn-container" buttonFile={require('./images/buttonc.svg')} caption="Character Design"/>
                    <Button changePage={changePage} pageName="animation" innerClassName="btn-small" containerClassName="animation-btn-container" buttonFile={require('./images/buttona.svg')} caption="Animation"/>
                    <Button changePage={changePage} pageName="graphic" innerClassName="btn-small" containerClassName="graphic-btn-container" buttonFile={require('./images/buttong.svg')} caption="Graphic Design"/>
                    <Button changePage={changePage} pageName="uxui" innerClassName="btn-smaller" containerClassName="uxui-btn-container" buttonFile={require('./images/buttonu.svg')} caption="UX/UI Design"/>
                </div>
            </div>
            <div className="heading-left darker">
                <h1>Character Design</h1>
            </div>
            <div className="heading-bar-left">
                <img src={require('./images/chardesign/bc2.jpg')}/>
            </div>
            <div className="centered-full medium">
                Character development is my bread-and-butter! Included in this section are a variety of step-by-step, sketchbook, and life drawings.
            </div>
            <div className="design-sheets-section">
                <div className="design-sheets-heading light">
                    <h2>Design Sheets</h2>
                </div>
                <div className="chardesign-btn-bar">
                    <img className="chardesign-btn-1 clickable" src={require('./images/chardesign/buttons/cdb1.png')} onClick={() => setImage(image1)} />
                    <img className="chardesign-btn-2 clickable" src={require('./images/chardesign/buttons/cdb2.png')} onClick={() => setImage(image2)} />
                    <img className="chardesign-btn-3 clickable" src={require('./images/chardesign/buttons/cdb3.png')} onClick={() => setImage(image3)} />
                    <img className="chardesign-btn-4 clickable" src={require('./images/chardesign/buttons/cdb4.png')} onClick={() => setImage(image4)} />
                    <img className="chardesign-btn-5 clickable" src={require('./images/chardesign/buttons/cdb5.png')} onClick={() => setImage(image5)} />
                    <img className="chardesign-btn-6 clickable" src={require('./images/chardesign/buttons/cdb6.png')} onClick={() => setImage(image6)} />
                </div>
            </div>
            <div className="step-by-step-section">
                <div className="subheading-off-center-left darker step-by-step-heading">
                    <h2>Step-by-Step Process</h2>
                </div>
                <div className="step-by-step-container">
                    <div className="two-image-arrow-box">
                        <img className="chardesign-btn-7 clickable arrowbox-btn-1" src={require('./images/chardesign/buttons/cdb7.png')} onClick={() => setImage(image7)} />
                        <img className="chardesign-btn-8 clickable arrowbox-btn-2" src={require('./images/chardesign/buttons/cdb8.png')} onClick={() => setImage(image8)} />
                        <img className="arrowbox-arrow" src={require('./images/chardesign/bluearrow.svg')} />
                    </div>
                    <div className="step-by-step-pairs">
                        <div className="step-by-step-pair">
                            <img className="chardesign-btn-9 clickable" src={require('./images/chardesign/buttons/cdb9.png')} onClick={() => setImage(image9)} />
                            <img className="chardesign-btn-10 clickable" src={require('./images/chardesign/buttons/cdb10.png')} onClick={() => setImage(image10)} />
                            <img className="pair-line" src={require('./images/chardesign/buttons/blueline.svg')} />
                        </div>
                        <div className="step-by-step-pair">
                            <img className="chardesign-btn-17 clickable" src={require('./images/chardesign/buttons/cdb17.png')} onClick={() => setImage(image17)} />
                            <img className="chardesign-btn-18 clickable" src={require('./images/chardesign/buttons/cdb18.png')} onClick={() => setImage(image18)} />
                            <img className="pair-line" src={require('./images/chardesign/buttons/blueline.svg')} />
                        </div>
                        <div className="step-by-step-pair">
                            <img className="chardesign-btn-11 clickable" src={require('./images/chardesign/buttons/cdb11.png')} onClick={() => setImage(image11)} />
                            <img className="chardesign-btn-12 clickable" src={require('./images/chardesign/buttons/cdb12.png')} onClick={() => setImage(image12)} />
                            <img className="pair-line" src={require('./images/chardesign/buttons/blueline.svg')} />
                        </div>
                        <div className="step-by-step-pair">
                            <img className="chardesign-btn-13 clickable" src={require('./images/chardesign/buttons/cdb13.png')} onClick={() => setImage(image13)} />
                            <img className="chardesign-btn-14 clickable" src={require('./images/chardesign/buttons/cdb14.png')} onClick={() => setImage(image14)} />
                            <img className="pair-line" src={require('./images/chardesign/buttons/blueline.svg')} />
                        </div>
                        <div className="step-by-step-pair">
                            <img className="chardesign-btn-15 clickable" src={require('./images/chardesign/buttons/cdb15.png')} onClick={() => setImage(image15)} />
                            <img className="chardesign-btn-16 clickable" src={require('./images/chardesign/buttons/cdb16.png')} onClick={() => setImage(image16)} />
                            <img className="pair-line" src={require('./images/chardesign/buttons/blueline.svg')} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="life-drawings-and-sketchbook">
                <div className="life-drawings light">
                    <h2>Life Drawings</h2>
                    <img className="chardesign-btn-19 clickable" src={require('./images/chardesign/buttons/cdb19.png')} onClick={() => setImage(image19)} />
                    <img className="chardesign-btn-20 clickable" src={require('./images/chardesign/buttons/cdb20.png')} onClick={() => setImage(image20)} />
                    <img className="chardesign-btn-21 clickable" src={require('./images/chardesign/buttons/cdb21.png')} onClick={() => setImage(image21)} />
                    <img className="chardesign-btn-22 clickable" src={require('./images/chardesign/buttons/cdb22.png')} onClick={() => setImage(image22)} />
                    <img className="chardesign-btn-23 clickable" src={require('./images/chardesign/buttons/cdb23.png')} onClick={() => setImage(image23)} />
                    <img className="chardesign-btn-24 clickable" src={require('./images/chardesign/buttons/cdb24.png')} onClick={() => setImage(image24)} />
                </div>
                <div className="sketchbook light">
                    <h2>Sketchbook</h2>
                    <img className="chardesign-btn-25 clickable" src={require('./images/chardesign/buttons/cdb25.png')} onClick={() => setImage(image25)} />
                    <img className="chardesign-btn-26 clickable" src={require('./images/chardesign/buttons/cdb26.png')} onClick={() => setImage(image26)} />
                    <img className="chardesign-btn-27 clickable" src={require('./images/chardesign/buttons/cdb27.png')} onClick={() => setImage(image27)} />
                    <img className="chardesign-btn-28 clickable" src={require('./images/chardesign/buttons/cdb28.png')} onClick={() => setImage(image28)} />
                    <img className="chardesign-btn-29 clickable" src={require('./images/chardesign/buttons/cdb29.png')} onClick={() => setImage(image29)} />
                    <img className="chardesign-btn-30 clickable" src={require('./images/chardesign/buttons/cdb30.png')} onClick={() => setImage(image30)} />
                </div>
            </div>
            <img src={require('./images/animation/ba4.jpg')} />
            <div className="copyright-info">
                © Christina Winchester; 2019
            </div>
        </div>
      </div>
    );
  }
}

export default CharacterPage;
